import { render } from "./UserStats.vue?vue&type=template&id=61f451b5&scoped=true"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"

import "./UserStats.vue?vue&type=style&index=0&id=61f451b5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f451b5"]])

export default __exports__